import React from 'react'
import "./projectXLarge.css"
import "./project.css"
import "./projectMedium.css"
import "./projectSmall.css" 
import "./projectXSmall.css"
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";



// CAN BE OPTIMIZED
const Project = (props) => {

    return (
        
            <section className='section-project'>
                <div className='zoom-img' >
                    <img src={props?.item?.image} className='projectImg' alt="project visual"/>
                </div>

                <div className='content'>
                    <div className='shadowBackground'></div>
                    <div className='slider-info-wrapper'>
                        <h1>{props?.item?.name}</h1>

                        <div className={props?.item?.nothing ? 'comingSoon-wrapper' : 'hidden absolute' }>
                            <p className='comingSoon' >Coming soon !</p>
                        </div>

                        <div className={props?.item?.nothing ? 'hidden absolute'  : 'slider-tech' }>
                                
                            {props?.item?.tech?.map((techLogo,index) => {
                                    return <img key={index} src={techLogo?.logo} title={techLogo?.title} loading="lazy" alt="Technology"/>
                                })}
                        </div>

                        <p>{props?.item?.desc}</p> 

                        <button onClick={() => props?.onClick()} className={props?.item?.nothing ? 'hidden absolute'  : 'main-button popup-btn' }>Learn more</button>
                    </div>
                </div>
            </section>
               
    )
}

export default Project